module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"burger-button":{"aria-label":"Åbn menu"}},"de":{"burger-button":{"aria-label":"Menü öffnenount"}},"fr":{"burger-button":{"aria-label":"Ouvrir le menu"}},"nl":{"burger-button":{"aria-label":"Menu openen"}}}')
  delete Component.options._Ctor
}
